import { BadgeVariant } from '@property.com.au/ui-kit';
import { AccordionInteractionEventData } from '../../analytics/event-tracking/trackAccordionInteraction';
import { WebLinkProps } from '../../app-kit/components/WebLink/WebLink';

type Fact = {
  subtitle: string;
  title: string;
};

type StarRatingFact = {
  accessibilityTitle: string;
  displayStarRatingPercentage: number;
  subtitle: string;
  title: string;
};

export type ChildcareFact = Fact | StarRatingFact;

export const isStarRatingFact = (childcareFact: ChildcareFact): childcareFact is StarRatingFact =>
  'displayStarRatingPercentage' in childcareFact;

export interface ChildcareCentre {
  name: string;
  vacancyBadge: {
    text: string;
    variant: BadgeVariant;
  };
  openingHours?: string | null;
  address: string;
  isDefaultOpen: boolean;
  childcareFacts: ChildcareFact[];
  webLinks: WebLinkProps[];
  tracking: {
    expand?: AccordionInteractionEventData | null;
    collapse?: AccordionInteractionEventData | null;
  };
}
